import React, { useRef } from 'react';
var VeltNotificationsPanelHeaderTabForYou = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-header-tab-for-you", { ref: ref }, children));
};
export default VeltNotificationsPanelHeaderTabForYou;
